module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert--small"
  }, [_c('h4', [_vm._v("\n    " + _vm._s(_vm.i18n['following_persons_are_on_the_lesson_but_not_on_school']) + " " + _vm._s(_vm.activeSchoolName) + ".\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "d-cal__group"
  }, _vm._l((_vm.usersNotOnSchool), function(calendar) {
    return _c('div', {
      key: calendar.calendar_id,
      staticClass: "d-cal-not-on-school",
      attrs: {
        "data-cal-id": calendar.calendar_id
      }
    }, [_vm._v("\n      " + _vm._s(calendar.name) + " "), (calendar.substitute) ? _c('span', {
      staticClass: "do-pill do-pill--custom"
    }, [_vm._v(_vm._s(_vm.i18n['sub']))]) : _vm._e(), _vm._v(" "), (!_vm.isEventOwner(calendar)) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'top'
        }),
        expression: "{\n                    arrow: true,\n                    placement : 'top'\n                  }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--danger icon__bg-circle--x-small",
      attrs: {
        "content": _vm.i18n['remove']
      },
      on: {
        "click": function($event) {
          return _vm.setTheRemoveCalendar(calendar)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.theRemoveCalendar) ? _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.setTheRemoveCalendar(null)
      }
    }
  }, [_c('div', {
    staticClass: "d-modal__d-calendar text-dark",
    class: {
      'd-modal__d-calendar--with-actions': true
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__d-calendar__header text-dark"
  }, [_c('h2', [_vm._v(_vm._s(_vm.theRemoveCalendar.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.setTheRemoveCalendar(null)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__d-calendar__content"
  }, [_c('div', {
    staticClass: "alert width-100"
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n['remove']) + " " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['from_this_lesson']) + "?")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-danger width-100",
    attrs: {
      "disabled": _vm.isRemoving
    },
    on: {
      "click": function($event) {
        return _vm.removeCalendar(_vm.theRemoveCalendar)
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n['remove']) + "\n            " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['from_this_lesson']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "alert"
  }, [_c('h4', {
    staticClass: "marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.i18n['remove_or_replace']) + " " + _vm._s(_vm.theRemoveCalendar.name) + " " + _vm._s(_vm.i18n['on']) + "\n            " + _vm._s(_vm.event.title) + " " + _vm._s(_vm.i18n['onwards']) + "?")]), _vm._v(" "), _c('CalendarViewDayRemoveOrReplace', {
    staticClass: "width-100 d-event__actions--custom",
    attrs: {
      "isPossibleToAdd": false,
      "event": _vm.event,
      "calendar": _vm.theRemoveCalendar,
      "calendars": _vm.userCalendars
    },
    on: {
      "updateAndClose": _vm.updateAndClose
    }
  })], 1)])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-197b3206!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarShowEventUsersNotOnSchool.vue
// module id = 1779
// module chunks = 1